import React from 'react'
import { HttpResponseError, useFetch } from './useFetch'
import Loading, { ErrorPage } from '../components/Loading'
import NotFound from '../components/NotFound'

type Props = {
  apiCall: ReturnType<typeof useFetch>
  render: (data: any) => JSX.Element
}

export function ApiResponseAware ({ apiCall, render }: Props) {
  if (apiCall.error) {
    if (
      apiCall.error instanceof HttpResponseError &&
      apiCall.error.status === 404
    ) {
      return <NotFound />
    } else {
      return <ErrorPage />
    }
  }

  if (apiCall.isLoading || !apiCall.data) {
    return <Loading />
  }

  return render(apiCall.data)
}
